import PastContributionView from './PastContributionView';

export default PastContributionView;
